import { axiosInstance } from ".."

const media = async (file) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.post(`internal/media/upload`,file).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default media;